export * from './imei.validator';
export * from './email.validator';



// WEBPACK FOOTER //
// ./src/app/shared/validators/index.ts